import React from 'react';
import { T } from 'Actions/translate';

class OrderBillToDetail extends React.Component {
    render() {
        const { data } = this.props;
        return (
            <div className={ `order-bill-to-detail-container ${ this.props.className }`}>
                <h4 className="order-bill-to-detail-title"><label>{T('order_invoice_title')}</label>
                 <p>{ data.invoiceTitle }</p>
                </h4>
                <div className="row mb-4">
                    <div className="text-ellipsis"><label>{T('order_consignee')}</label> { data.invoiceReceiver }</div>
                </div>
                <div className="row mb-4">
                    <div className="text-ellipsis"><label>{T('order_contact')}</label> <a className='shipment-list-shippment_contact'  href={`tel:${data.invoiceReceiverTel}`} >{ data.invoiceReceiverTel }</a></div>
                </div>
                <div className="row mb-4">
                    <div className="text-ellipsis"><label>{T('email')}</label> { data.invoiceReceiverEmail }</div>
                </div>
                <div className="row address mb-14">
                    <label className="address-label">{T('order_address')}</label> <span className="address-value">{ data.invoiceReceiverAddress }</span>
                </div>
            </div>
        );
    }
}

export default OrderBillToDetail;
